import s from './GigAssChatOpener.module.sass'
import { StarIcon } from '../../ui/StarIcon'

import { FC } from 'react'
import { EGG } from '@shared/api/analytics'
import { Text } from '@shared/ui/Typography/Text'
import TailBubble from '@icons/gigachat/tail-bubble.svg'
import useFeatureFlag from '@shared/lib/hooks/useFeatureFlag'
import { useAssistOpenUrl } from '../../hooks/useAssistOpen'
import { useAppSelector } from '@app/model/store'
import { useChatButtonLogic } from '@widgets/Common/GigAssist/hooks/useChatButtonLogic'
import { BUTTON_OPENER_CONST } from '@widgets/Common/GigAssist/model/slice'
import { useIntersection } from '@shared/lib/hooks/useIntersection'

const ASSISTANT_BUBBLE = 'Помочь с выбором?'

interface ButtonHandleOpenProps {
  mode: 'fixed-long' | 'fixed-short' | 'static-long'
  // 'fixed-long' - широкий блок для левого нижнего угла окна (как на главной)
  // 'fixed-short' - квадратный блок для левого нижнего угла окна (как на странице ресторанов с бронью)
  // 'static' - статичный блок (перед футером)

  isHideAnim: boolean
  className?: string
}

const GigAssChatOpenerContainer: FC<ButtonHandleOpenProps> = (props) => {
  const userData = useAppSelector((state) => !!state.global?.user?.data)
  const assistFlag = useFeatureFlag('gigachat')
  const isAssistantActive = userData || assistFlag

  if (!isAssistantActive) return null

  return <GigAssChatOpener {...props} />
}

const GigAssChatOpener: FC<ButtonHandleOpenProps> = ({ mode, isHideAnim, className = '' }) => {
  useChatButtonLogic()
  const { showBubble, buttonText, animationIndex } = useAppSelector((store) => store.gigAssist.buttonOpener)
  const { handleOpenWithUrl } = useAssistOpenUrl()

  const isLongStyle = mode === 'fixed-long' || mode === 'static-long'
  const isShortStyle = mode === 'fixed-short'

  const isVisibleStaticButton = useIntersection("[data-style='static-long']", {}, true)
  const isHideFixedButton = (mode === 'fixed-long' || mode === 'fixed-short') && isVisibleStaticButton

  const handleOpen = () => {
    EGG.gigachat.assistant_button_click()
    handleOpenWithUrl()
  }

  const getIndexButtonText = () => {
    if (buttonText === BUTTON_OPENER_CONST.DEFAULT_TEXT) return 0

    return animationIndex + 1
  }

  return (
    <div
      className={`${s.buttonContainer} ${className}`}
      data-style={mode}
      data-hide-fixed-button={isHideFixedButton}
      data-hide-anim={isHideAnim}>
      <div className={s.gradientGroup} />
      <button type='button' className={s.buttonHandleOpen} onClick={handleOpen} data-key='form-button'>
        <div className={s.starIcon}>
          <StarIcon />
        </div>

        <div className={s.bubble} data-active={showBubble}>
          <Text sizes={'S'}>{ASSISTANT_BUBBLE}</Text>
          <TailBubble className={s['tail-bubble']} />
        </div>

        {isLongStyle && (
          <div className={s.textWrapper}>
            <div
              className={s.textContainer}
              data-hide={BUTTON_OPENER_CONST.ALT_TEXT.length === animationIndex + 1}
              style={{ transform: `translateY(${-20 * getIndexButtonText() + 15}px)` }}>
              <span className={`${s.buttonText}`}>{BUTTON_OPENER_CONST.DEFAULT_TEXT}</span>
              {BUTTON_OPENER_CONST.ALT_TEXT.map((el, index) => (
                <span className={`${s.buttonText}`} key={el}>
                  {el}
                </span>
              ))}
            </div>
          </div>
        )}
      </button>
    </div>
  )
}

export default GigAssChatOpenerContainer
